import { render, staticRenderFns } from "./thav_sketch.vue?vue&type=template&id=917b606e&scoped=true"
import script from "./thav_sketch.vue?vue&type=script&lang=js"
export * from "./thav_sketch.vue?vue&type=script&lang=js"
import style0 from "./thav_sketch.vue?vue&type=style&index=0&id=917b606e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917b606e",
  null
  
)

export default component.exports